import { Component, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { CustomNotificationFormComponent } from "./custom-notification-form/custom-notification-form-component";
// import {
//     NotificationListComponent
// } from "../../../shared/layouts/cameralla-layout/notification/component/notification-list.component/notification-list.component";
import { CTableComponent } from "../../../core/ui/c-table/c-table.component";
import { PresetFormComponent } from "./preset-form/preset-form-component";
import { PresetService } from "../../../shared/services/preset.service";
import { CTableCell } from "../../../core/ui/c-table/c-table-config";
import { ActivatedRoute } from "@angular/router";
import AppShareHelper from "../../../shared/utils/helper";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { jobType } from "../../../shared/constants/scheduled-job-constant";

@Component({
  selector: "app-preset-action-col-component",
  template: `<button
      class="btn btn-primary text-white"
      title="Go to detail"
      (click)="extraData.openDetail(row.entity)"
    >
      <i class="fa fa-eye"></i>
    </button>
    <button
      class="btn btn-primary text-white ml-1"
      title="Remove"
      (click)="extraData.remove(row.entity)"
    >
      <i class="fa fa-trash"></i>
    </button> `,
})
export class PresetActionColComponent implements CTableCell {
  extraData;
  row;
  column;
}

@Component({
  selector: "app-app-management-component",
  templateUrl: "./app-management-component.html",
})
export class AppManagementComponent {
  constructor(
    protected http: HttpClient,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private scheduleService: ScheduleService,
    public presetService: PresetService,
    protected _modalService: NgbModal
  ) {}

  testingMode = false;
  @ViewChild("notificationList")
  notificationListViewChild: CTableComponent;

  @ViewChild("scheduledJobs")
  scheduledJobsViewChild: CTableComponent;

  @ViewChild("presetListViewChild")
  presetListViewChild: CTableComponent;

  ngOnInit() {
    this.testingMode = this.route.snapshot.queryParams.testingMode;
  }
  notificationManagement = {
    useLocalTable: false,
    usePaging: true,
    isAutoload: true,
    columnDefs: [
      {
        cellClass: "text-capitalize",
        displayName: "Title",
        field: "title",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Message",
        field: "message",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Display",
        field: "display",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Device type",
        field: "deviceType",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Member type",
        field: "memberType",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Language",
        field: "language",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Group",
        field: "groupName",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Time",
        field: "createdDate",
        cellPipe: "cDateTime",
      },
    ],
    extraData: {},

    refresh: (params, table) => {
      let paging = {
        skip: (params._page - 1) * params._pageSize,
        limit: params._pageSize,
        where: {
          or: [
            { type: 10 }, //Custom noti for app
            { type: 22 }, //Custom noti for web
          ],
        },
        include: "group",
        order: "create_at DESC",
      };

      let pagingUrl = encodeURIComponent(JSON.stringify(paging));
      // this.http.get(NotificationListComponent.notificationUrl +  '/original' + `?filter=${pagingUrl}`)
      //     .subscribe(
      //         (res: any) => {
      //             const parsedData = [];
      //             if (res.Data && res.Data.Data.length) {
      //                 res.Data.Data.forEach((item) => {
      //                     const content = JSON.parse(item.content).data;
      //                     parsedData.push({
      //                         id: item.id,
      //                         title: content.title,
      //                         message: content.message,
      //                         display: item.type == 22 ? 'Web' : 'App',
      //                         language: item.language ? 'English' : 'Norwegian',
      //                         deviceType: item.deviceType ? item.deviceType : 'All',
      //                         memberType: item.memberType ? item.memberType : 'All',
      //                         navigateUrl: content.navigateUrl,
      //                         createdDate: item.create_at,
      //                         groupName: item.groupId ? item.group.name : 'N/A',
      //                     });
      //                 })
      //                 table.setData(parsedData, res.Data.Count);
      //             } else {
      //                 table.setData([], 0);
      //             }
      //         },
      //         (error) => {
      //             this.toastr.error(error.error.Message, 'Error');
      //         }
      //     );
    },
  };

  scheduledJobsManagement = {
    useLocalTable: false,
    usePaging: true,
    isAutoload: true,
    columnDefs: [
      {
        cellClass: "text-capitalize",
        displayName: "Name",
        field: "name",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Type",
        field: "type",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Run at",
        field: "triggeredAt",
        cellPipe: "cDateTime",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Status",
        field: "status",
        cellPipe: "scheduledJobStatus",
      },
      {
        cellClass: "text-capitalize",
        displayName: "GroupId",
        field: "groupId",
        cellPipe: "cText",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Action",
        cellComponent: PresetActionColComponent,
      },
    ],
    extraData: {
      openDetail: (entity) => {
        if (entity.type === jobType.NOTIFICATION) {
          const modal = this._modalService.open(
            CustomNotificationFormComponent,
            { centered: true, size: "lg" }
          );
          modal.componentInstance.triggeredAt = entity.triggeredAt;
          modal.componentInstance.jobId = entity.id;
          modal.componentInstance.triggeredTime = "scheduled";
          if (new Date(modal.componentInstance.triggeredAt) <= new Date()) {
            modal.componentInstance.disableSubmit = true;
          }
          modal.componentInstance.model = entity.params;
          modal.componentInstance.onRefresh.subscribe((e) => {
            this.scheduledJobsViewChild.refresh();
          });
        }
      },
      remove: (entity) => {
        if (confirm("Are you sure?")) {
          this.scheduleService
            .deleteScheduledJob(entity.id)
            .toPromise()
            .then(() => {
              this.scheduledJobsViewChild.refresh();
            });
        }
      },
    },

    refresh: (params, table) => {
      let paging = {
        skip: (params._page - 1) * params._pageSize,
        limit: params._pageSize,
        order: "status DESC",
      };

      let pagingUrl = encodeURIComponent(JSON.stringify(paging));
      this.scheduleService
        .getScheduledJob(`?filter=${pagingUrl}`, { observe: "response" })
        .subscribe(
          (res: any) => {
            if (res.body.Data && res.body.Data.length) {
              table.setData(res.body.Data, res.headers.get("X-Total-Count"));
            } else {
              table.setData([], 0);
            }
          },
          (error) => {
            this.toastr.error(error.error.Message, "Error");
          }
        );
    },
  };

  presetList = {
    useLocalTable: false,
    usePaging: true,
    isAutoload: true,
    columnDefs: [
      {
        cellClass: "text-capitalize",
        displayName: "ID",
        field: "id",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Title",
        field: "name",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Type",
        field: "type",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Category",
        field: "category",
        cellPipe: "cPresetCategory",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Created at",
        field: "createdAt",
        cellPipe: "cDateTime",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Status",
        field: "status",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Group",
        field: "groupName",
      },
      {
        cellClass: "text-capitalize",
        displayName: "Action",
        cellComponent: PresetActionColComponent,
      },
    ],
    extraData: {
      openDetail: (entity) => {
        const modal = this._modalService.open(PresetFormComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.model = AppShareHelper.deepClone(entity);
        if (entity.groupId) {
          modal.componentInstance.model.groupSearchValue = entity.group.name;
          modal.componentInstance.groupId = entity.groupId;
        }
        modal.componentInstance.onRefresh.subscribe((e) => {
          this.presetListViewChild.refresh();
        });
      },
      remove: (entity) => {
        if (confirm("Are you sure?")) {
          this.presetService
            .deletePreset(entity.id)
            .toPromise()
            .then(() => {
              this.presetListViewChild.refresh();
            });
        }
      },
    },

    refresh: (params, table) => {
      let paging = {
        skip: (params._page - 1) * params._pageSize,
        limit: params._pageSize,
        order: "createdAt DESC",
        include: "group",
      };

      let pagingUrl = encodeURIComponent(JSON.stringify(paging));
      this.http
        .get(PresetService.presetAPI + `?filter=${pagingUrl}`, {
          observe: "response",
        })
        .subscribe(
          (res: any) => {
            if (res.body.Data && res.body.Data.length) {
              res.body.Data.forEach((item) => {
                item.groupName = item.group ? item.group.name : "N/A";
              });
              table.setData(res.body.Data, res.headers.get("X-Total-Count"));
            } else {
              table.setData([], 0);
            }
          },
          (error) => {
            this.toastr.error(error.error.Message, "Error");
          }
        );
    },
  };

  addCustomNotification() {
    const modal = this._modalService.open(CustomNotificationFormComponent, {
      centered: true,
      size: "lg",
    });
    modal.componentInstance.onRefresh.subscribe((e) => {
      this.notificationListViewChild.refresh();
      this.scheduledJobsViewChild.refresh();
    });
  }

  addPreset() {
    const modal = this._modalService.open(PresetFormComponent, {
      centered: true,
      size: "lg",
    });
    modal.componentInstance.onRefresh.subscribe((e) => {
      this.presetListViewChild.refresh();
    });
  }
}
